
import { useState } from 'react';
import { useToast } from '@/hooks/use-toast';

export interface DeviceGroup {
  id: string;
  name: string;
  type: string;
  department: string;
  deviceCount: number;
}

const initialGroups: DeviceGroup[] = [
  { id: '1', name: 'HVAC Controllers', type: 'Energy', department: 'Energy', deviceCount: 12 },
  { id: '2', name: 'Floor 1 Meters', type: 'Energy', department: 'Energy', deviceCount: 8 },
  { id: '3', name: 'Main Gas Meters', type: 'Gas', department: 'Gas', deviceCount: 3 },
  { id: '4', name: 'Water Distribution', type: 'Water', department: 'Water', deviceCount: 5 },
];

export const useDeviceGroups = () => {
  const [groups, setGroups] = useState<DeviceGroup[]>(initialGroups);
  const [searchTerm, setSearchTerm] = useState('');
  const [addDialogOpen, setAddDialogOpen] = useState(false);
  const [newGroupData, setNewGroupData] = useState({
    name: '',
    type: 'Energy',
    department: 'Energy'
  });
  const { toast } = useToast();

  const filteredGroups = groups.filter(group => 
    group.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    group.type.toLowerCase().includes(searchTerm.toLowerCase()) ||
    group.department.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleDeleteGroup = (id: string) => {
    setGroups(groups.filter(group => group.id !== id));
    toast({
      title: "Group Deleted",
      description: "The device group has been removed."
    });
  };

  const handleAddGroup = (name: string, type: string, department: string) => {
    if (!name.trim()) {
      toast({
        title: "Validation Error",
        description: "Group name is required.",
        variant: "destructive"
      });
      return;
    }

    const newGroup: DeviceGroup = {
      id: Date.now().toString(),
      name,
      type,
      department,
      deviceCount: 0
    };

    setGroups([...groups, newGroup]);
    setNewGroupData({
      name: '',
      type: 'Energy',
      department: 'Energy'
    });
    
    toast({
      title: "Group Added",
      description: `${newGroup.name} group has been created successfully.`
    });
  };

  return {
    groups,
    filteredGroups,
    searchTerm,
    setSearchTerm,
    newGroupData,
    setNewGroupData,
    addDialogOpen, 
    setAddDialogOpen,
    handleAddGroup,
    handleDeleteGroup
  };
};
